import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
// const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'sal_center': {
    title: '公司/营销单元',
    type: 'select',
    equation: all,
    dictionary: 'saleCompnay'
  },
  'sal_center_name': {
    title: '公司/营销单元描述',
    type: 'input'
  }
}

export default {
  'plan_number': {
    title: '销售计划编号',
    type: 'input',
    equation: all,
    slot: true
  },
  'sal_center_name': {
    title: '公司/营销单元'
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    showDescribeInput: true,
    describeTitle: '存货分类描述',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
  'total_qty': {
    title: '总计划量(吨)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'initplan_qty': {
    title: '初始计划量(吨)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'total_amt': {
    title: '总计划额(万元)',
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  },
  'initplan_amt': {
    title: '初始计划额(万元)',
    width: 130,
    xlsxFmt: {
      t: 'n'
    },
    formatter: ({ cellValue }) => {
      if (cellValue?.endsWith('-')) {
        return '-' + cellValue.replace('-', '')
      } else {
        return cellValue
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanQueryCompany.js